import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

function TotalVisitors() {
  const { visitor } = useContext(AuthContext);

  const rederVisitor = () => {
    if (visitor !== null) {
      return new Intl.NumberFormat().format(visitor.length);
    } else {
      return "0";
    }
  };

  return (
    <div className="total-visitors divContent darktextColor darkdivColor">
      <p className="text">
        Visitors <span className="textSmall">(last 1 month)</span> :
      </p>
      <h4>{rederVisitor()}</h4>
    </div>
  );
}

export default TotalVisitors;
